// Auth rijdt mee in de HttpOnly-cookie (apiFetch stuurt `credentials: 'include'`)
// en apiFetch zet zelf de X-Tmc-Client-header, dus een request heeft hier alleen
// nog een Content-Type voor zijn JSON-body nodig.
export const JSON_HEADERS = {
  'Content-Type': 'application/json',
} as const

// btoa() werkt niet op codepoints buiten ASCII, vandaar de omweg via TextEncoder.
function utf8ToBase64(value: string): string {
  const bytes = new TextEncoder().encode(value)
  return btoa(Array.from(bytes, (b) => String.fromCharCode(b)).join(''))
}

export function basicAuthHeader(email: string, password: string): string {
  return `Basic ${utf8ToBase64(`${email}:${password}`)}`
}
